module.exports = __webpack_public_path__ + "static/Band-03b2398c99cb343f4f14d6cf89faf4f2.jpg";